"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_ZHHK_TRANS = {
    'time picker': '時間',
    'today': '今天',
    'set time': '設置時間',
    'close': '關閉',
    'cancel': '取消',
    'confirm': '確認',
    'hour': '時',
    'minute': '分',
    'second': '秒',
};
//# sourceMappingURL=zh-hk.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/zh-hk.js
// module id = ../../../../ng-pick-datetime/locale/zh-hk.js
// module chunks = 18